import { Component, Input, Output, EventEmitter } from '@angular/core';

interface metexportar {
  name: string;
  icon: string;
}

@Component({
  selector: 'app-exportar',
  standalone: true,
  imports: [],
  templateUrl: './exportar.component.html',
  styleUrl: './exportar.component.css',
})
export class ExportarComponent {
  @Input() data: any[] = [];
  @Output() exportar = new EventEmitter<string>();

  metexportar: metexportar[] = [
    {
      name: 'word',
      icon: './assets/word.svg',
    },
    {
      name: 'excel',
      icon: './assets/excel.svg',
    },
    {
      name: 'text',
      icon: './assets/text.svg',
    },
    {
      name: 'pdf',
      icon: './assets/pdf.svg',
    },
  ];

  // Método para exportar
  exportarArchivo(formato: string) {
    this.exportar.emit(formato);
  }
}
